import React, { useState, useEffect } from "react";

import { useBranchName } from "hooks/branchName/useBranchName";

import BranchDetail from "components/branches/BranchDetails";
import BranchUsers from "components/branches/BranchUsers";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import "./branches.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const BranchDetails = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setBranchNameContext } = useBranchName();
  const [activeTab, setActiveTab] = useState("detail");
  const [branchName, setBranchName] = useState("");

  const handleTab = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    setBranchNameContext(branchName);
  }, [branchName]);

  return (
    <>
      <div className="main mt-3">
        <div className="custom-breadcrumbs ">
          <span
            className="breadcrumbs-item "
            onClick={() => {
              navigate("/branches");
            }}
          >
            {t("branches")}
          </span>
          <span className="breadcrumbs-item">
            <p>{branchName}</p>
          </span>
        </div>
        <div className="custom-tabs-container">
          <ul className="tabs-nav-custom text-uppercase">
            <li
              className={activeTab === "detail" ? "active" : ""}
              onClick={() => handleTab("detail")}
            >
              {t("detail")}
            </li>

            {/* <li
              className={activeTab === "users" ? "active" : ""}
              onClick={() => handleTab("users")}
            >
              {t("users")}
            </li> */}
          </ul>
          {activeTab === "detail" ? (
            <BranchDetail
              handleBranchName={(key) => {
                setBranchName(key);
              }}
              handleTab={handleTab}
            />
          ) : (
            <BranchUsers />
          )}
        </div>
      </div>
    </>
  );
};

export default BranchDetails;
